import { Button } from '@finn/design-system/atoms/button';
import { RawHtml } from '@finn/platform-modules';
import { cn, useCurrentLocale } from '@finn/ui-utils';
import { useLayoutEffect, useMemo, useRef } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

type Props = {
  content: string;
  centered: boolean;
  className?: string;
};

export const renderButtonLink = (href: string, label: string) => {
  return renderToStaticMarkup(
    <Button
      variant="action"
      href={href}
      className="cta-button my-4 hover:text-white"
    >
      {label}
    </Button>
  );
};

export const renderUserCentricsJS = (label: string) => {
  return renderToStaticMarkup(
    <a className="cookie-policy-link cursor-pointer">{label}</a>
  );
};

export const enrichHtmlContent = (content: string, locale: string) => {
  return content
    .replace(/\[Button:([^:]+):([^\]]+)\]/g, (_, p1, p2) =>
      renderButtonLink(`/${locale}/${p1}`, p2)
    )
    .replace(/\[UC:([^\]]+)\]/g, (_, p1) => renderUserCentricsJS(p1))
    .replaceAll('<table', "<div class='block w-full overflow-x-auto'><table")
    .replaceAll('</table>', '</table></div>');
};

const HTMLContent = ({ content, centered, className }: Props) => {
  const { locale } = useCurrentLocale();
  const ref = useRef<HTMLDivElement>(undefined);

  const enrichedHtml = useMemo(
    () => enrichHtmlContent(content, locale),
    [content, locale]
  );

  useLayoutEffect(() => {
    setTimeout(() => {
      const handleCookiePolicy = () => {
        window.UC_UI.showSecondLayer();
      };

      if (ref.current) {
        for (const element of ref.current.getElementsByClassName(
          'cookie-policy-link'
        )) {
          element.addEventListener('click', handleCookiePolicy);
        }
      }
    }, 500);
  }, [ref]);

  return (
    <div
      ref={ref}
      className={cn(
        'container sm:w-[calc(100%-2rem)] md:w-[calc(100%-1rem)] md:max-w-[726px] lg:relative',
        { 'sm:static sm:m-auto': centered },
        className
      )}
    >
      <RawHtml html={enrichedHtml} useGlobalStyles />
    </div>
  );
};

export default HTMLContent;
